export const SLUGS = [
    "city-hall",
    "bear-flag-monument",
    "mission-solano",
    "blue-wing-inn",
    "the-barracks",
    "swiss-hotel",
    "sonoma-plaza-saloons",
    "chinese-sonoma",
    "the-duck-pond",
    "bill-lynch"
  ]

export const BANNER = [
    ["Why a Plaza Here","Walk to the Starting Location"],
    ["Bear Flag Monument","Walk to the next destination"],
    ["Mission Solano","Walk to the next destination"],
    ["Blue Wing Inn","Walk to the nexst destination"],
    ["Solomon Schocken", "Walk to the next destination"],
    ["The Swiss Hotel", "Walk to the next destination"],
    ["Eldorado Hotel", "Walk to the next destination"],
    ["Chinese Sonoma", "Walk to the next destination"],
    ["The Duck Pond", "Walk to the next destination"],
    ["Bill Lynch", "Walk to the next destination"]
  ]

  export const NARRATIONS = [
    "https://firebasestorage.googleapis.com/v0/b/sonoma-tour.appspot.com/o/Why%20a%20plaza%20here%20Fixed.mp3?alt=media&token=113ec3ac-9028-4349-b74d-8d85932a09cc",
    "",
    // "https://firebasestorage.googleapis.com/v0/b/sonoma-tour.appspot.com/o/Blue%20Wing%20English%20Audio%20mp3.mp3?alt=media&token=3d8a625b-f0ce-4218-9ca4-e1c9837ecdb5",
    "https://firebasestorage.googleapis.com/v0/b/sonoma-tour.appspot.com/o/Mission%20English%20Correct%20Narration.mp3?alt=media&token=6e31e799-d54f-4bd4-b0a3-90825256f040",
    "https://firebasestorage.googleapis.com/v0/b/sonoma-tour.appspot.com/o/Blue%20Wing%20Englis%207-13-22.mp3?alt=media&token=7d9cc8c5-c640-4371-9369-709e48d7983e",
    "https://firebasestorage.googleapis.com/v0/b/sonoma-tour.appspot.com/o/Solomon%20Schocken%20English%20Audio.mp3?alt=media&token=cbffd4cd-96ed-46a8-9f6c-de1cff3018f2",
    "",
    "https://firebasestorage.googleapis.com/v0/b/sonoma-tour.appspot.com/o/Saloon%20English%20mp3.mp3?alt=media&token=a07f85e2-cbf9-48b5-96d7-50ab516fe9fb",
    "https://firebasestorage.googleapis.com/v0/b/sonoma-tour.appspot.com/o/Chinese%20Community%20Audio%20mp3.mp3?alt=media&token=1a0634dc-b479-46b5-869b-04026a1c4948",
    "",
    "https://firebasestorage.googleapis.com/v0/b/sonoma-tour.appspot.com/o/Bill%20lynch%20starts%20here%20extended.mp3?alt=media&token=0bb77057-f452-4d41-854a-3cd78a70f568"
  ]

export const NEXT_STOPS = [
  "The Bear Flag Monument",
  "Mission Solano",
  "Blue Wing Inn",
  "The Barracks",
  "Swiss Hotel",
  "Sonoma Plaza Saloons",
  "Chinese Sonoma",
  "The Duck Pond",
  "Bill Lynch"
]

export const INFO1 = [];

export const INFOS = [
    [
      {
        location: 'Sonoma City Hall'
      },
      {
        title: "Why a Plaza Here?",
        pt: 3
      },
      {
        subTitle:"A Story at the Barracks",
      },
      {
        p: `The Plaza didn’t just happen, California’s largest historic plaza
        has been the focus of deliberate planning.`,
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop1/1.png",
          mobileUrl: "../../../assets/stop1/1.png",
          footnote: "Aerial footage of Sonoma Plaza",
          alt: "Aerial footage of Sonoma Plaza"
        },
        pt: 3
      },
      {
        timebar: {
          date: "1830's",
          title: "The closing of the Missions"
        },
        pt: 3
      },
      {
        p: `<b>Mexico closed the 21 Alta California missions</b> and declared
        all church property be turned over to the Mexican Government.`,
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop1/clickable1-sm.png",
          mobileUrl: "../../../assets/stop1/clickable1-sm.png",
          footnote: "Alta California Missions",
          alt: "Alta California Missions"
        },
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop1/2.png",
          mobileUrl: "../../../assets/stop1/2.png",
          footnote: "Artwork of the Sonoma Mission by Robert Smilie (1975)",
          alt: "Artwork of the Sonoma Mission"
        },
        pt: 3
      },
      {
        timebar: {
          date: "1833",
          title: "General Vallejo"
        },
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop1/3.png",
          mobileUrl: "../../../assets/stop1/3.png",
          footnote: "Portrait of General Mariano Vallejo",
          alt: "Portrait of General Mariano Vallejo"
        },
        pt: 3
      },
      {
        list: {
          title: "Vallejo’s orders:",
          values: [
            "Establish a military post",
            "Promote settlement",
            "Develop a pueblo or town"
          ]
        }
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop1/4.png",
          mobileUrl: "../../../assets/stop1/4.png",
          footnote: "“Detail of View of the Presidio of San Francisco” by Louis Choris (1816). Courtesy Bancroft Library",
          alt: "Detail of View of the Presidio of San Francisco"
        },
        pt: 3
      },
      {
        timebar: {
          date: "1835",
          title: "The New Laws"
        },
        pt: 3
      },
      {
        p: `The Laws of the Indies regulated Spanish colonies for centuries.`,
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop1/5.png",
          mobileUrl: "../../../assets/stop1/5.png",
          footnote: "Laws of the Indies",
          alt: "Laws of the Indies"
        },
        pt: 3
      },
      {
        p: `The <b>Plaza</b>, established by General Vallejo would be the
        <b>starting point</b> for these new laws under an Independent Mexico governance.`,
        pt: 3
      },
      {
        timebar: {
          date: "1835",
          title: "Building a Town"
        },
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop1/6.png",
          mobileUrl: "../../../assets/stop1/6.png",
          footnote: "William Richardson",
          alt: "William Richardson"
        },
        pt: 3
      },
      {
        p: `English friend <b>William Richardson</b> extended the rough dirt street in
        front of the Mission and set another at right angles north and south. They named
        them “Calle Vallejo” and “Calle Cuartel”, now known as
        <b>Spain Street</b> and <b>First Street East</b>.`,
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop1/7.png",
          mobileUrl: "../../../assets/stop1/7.png",
          footnote: "Early Plaza photo",
          alt: "Early Plaza photo"
        },
        pt: 3
      },
      {
        p: `From that corner, the plaza and the town were eventually laid out.`,
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop1/8.png",
          mobileUrl: "../../../assets/stop1/8.png",
          footnote: "1880s Sanborn Fire Insurance map.",
          alt: "1880s Sanborn Fire Insurance map."
        },
        pt: 3
      },
      {
        timebar: {
          date: "Forward",
          title: "The Vision and Today"
        },
        pt: 3
      },
      {
        p: `The Laws envisioned the plaza as a place where people “could go for
        <b>recreation</b>” and <b>“pasture their cattle.”</b>`,
        pt: 3
      },
      {
        double_img: {
          desktopUrl_a: "../../../assets/stop1/9.png",
          mobileUrl_a: "../../../assets/stop1/9.png",
          footnote_a: "Cows “Courtesy Oak Hill Farms”",
          alt_a: "Cows “Courtesy Oak Hill Farms”",
          desktopUrl_b: "../../../assets/stop1/10.png",
          mobileUrl_b: "../../../assets/stop1/10.png",
          footnote_b: "Chickens",
          alt_b: "Chickens"
        },
        pt: 4
      },
      {
        p: `<b>In the old days,</b> people might have picnicked next to grazing cows.
        More recently, free-range roosters and chickens ran the plaza.`,
        pt: 3
      },
      {
        p: `<b>Times have changed,</b> but recreation on the Sonoma Plaza still holds
        sway—for humans and probably the ducks too.`,
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop1/11.png",
          mobileUrl: "../../../assets/stop1/11.png",
          footnote: "In Front of City Hall, the ducks play in the fountain with onlookers.",
          alt: "In Front of City Hall, the ducks play in the fountain with onlookers"
        },
        pt: 3
      },
      {
        quiz: {
          question: "What birds do you see on the square?",
          choices: [
            {
              choice: "Penguins",
              answer: false
            },
            {
              choice: "Eagles",
              answer: false
            },
            {
              choice: "Ducks",
              answer: true
            }
          ]
        }
      },
    ],
    [
      {
        timebar: {
          date: `1846`,
          title: "June Day"
        },
        pt: 3
      },
      {
        p: `This monument remembers the June day in 1846 when 
        <b>a band of Americans captured the Mexican pueblo</b> without
        a fight then declared an independent territory they called
        the <b>Bear Flag Republic</b>.`,
        pt: 3
      },
      {
        p: `This lasted just <b>25 days</b> before US
        soldiers arrived, a regiment from the Mexican-American War.`
      },
      {
        p: `The Bear Flag Revolt represents a controversial turning point
        in Sonoma history.`
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop2/1.png",
          mobileUrl: "../../../assets/stop2/1.png",
          footnote: "Image of California’s state flag, “the Bear Flag”",
          alt: "Image of California’s state flag, “the Bear Flag”"
        },
        pt: 3
      },
      {
        p: `While the republic was short-lived, <b>the Bear Flag lives
        on as the California state flag since its adoption in 1911.</b>`,
        pt: 3
      },
    ],
    [
      {
        location: 'Sonoma State Historic Park'
      },
      {
        timebar: {
          date: "1823",
          title: "Founded by Mexico"
        },
        pt: 2
      },
      {
        img: {
          size: "sm",
          desktopUrl: "../../../assets/stop3/1.png",
          mobileUrl: "../../../assets/stop3/1.png",
          footnote: "Mexican flag",
          alt: "The Mexican flag"
        },
        pt: 5
      },
      {
        p: "Mission San Francisco Solano was the only missionary <strong>founded by Mexico.</strong>",
        pt: 3
      },
      {
        img: {
          size: "sm",
          desktopUrl: "../../../assets/stop3/2.png",
          mobileUrl: "../../../assets/stop3/2.png",
          footnote: "Royal Standard of Spain",
          alt: "Royal Standard of Spain"
        },
        pt: 4
      },
      {
        p: "The original 20 Missions were founded by <strong>Spanish Missionaries.</strong>",
        pt: 3
      },
      {
        title: "El Camino Real (The Kings Road)",
        pt: 3
      },
      {
        p: "San Francisco Solano was the northern end of El Camino Real. The king’s road that stretched to San Diego.",
        pt: 4
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop3/4.png",
          mobileUrl: "../../../assets/stop3/4.png",
          footnote: "21 missions map - Zoomed into Northern Frontier",
          alt: "21 California missions map zoomed in on Mission San Francisco Solano"
        },
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop3/3.png",
          mobileUrl: "../../../assets/stop3/3.png",
          footnote: "21 missions map",
          alt: "A basic map of the 21 missions of California"
        },
        pt: 4
      },
      {
        timebar: {
          date: "Earlier",
          title: "Native Tribes"
        },
        pt: 3
      },
      {
        p: "History goes back much farther among people who lived in Sonoma Valley for 10,000+ years, a community of <strong>Coast Miwok, Pomo, Wappo and Wintun people.</strong>",
        pt: 3
      },
      {
        double_img: {
          desktopUrl_a: "../../../assets/stop3/5a.png",
          mobileUrl_a: "../../../assets/stop3/5a.png",
          footnote_a: "A Pomo Girl. By Edward S. Curtis. 1924",
          alt_a: "Photographic portrait of a Pomo girl, taken by Edward S. Curits in 1924",
          desktopUrl_b: "../../../assets/stop3/5b.png",
          mobileUrl_b: "../../../assets/stop3/5b.png",
          footnote_b: "A Wappo Man. By Edward S. Curtis. 1924",
          alt_b: "Photographic portrait of a Wappo man, taken by Edward S. Curits in 1924"
        },
        pt: 4
      },
      {
        timebar: {
          date: "1823-1834",
          title: "Mission Solano"
        },
        pt: 3
      },
      {
        p: "Mission Solano lasted just <strong>11 years</strong> but had a long-lasting effect, not just on Sonoma’s original natives but still today. The mission planted the first grapevines in what’s now known as \“Wine Country\”.",
        pt: 4
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop3/6.png",
          mobileUrl: "../../../assets/stop3/6.png",
          footnote: "Two glasses of wine over scenic vineyard.",
          alt: "Two glasses of wine over scenic vineyard in Sonoma"
        },
        pt: 4
      },
      {
        title: "Why and How did it end?",
        pt: 3
      },
      {
        p: "The short answer is politics. The Mexican government, newly independent from Spain, closed all 21 Alta California missions.",
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop3/7.png",
          mobileUrl: "../../../assets/stop3/7.png",
          footnote: "Mexican independence",
          alt: "Historic painting of Mexican independence"
        },
        pt: 0
      },
      {
        timebar: {
          date: "1835",
          title: "Mission Solano"
        },
        pt: 4
      },
      {
        p: "Our local story revolves around the arrival of <strong>General Mariano Vallejo</strong> and a contingent of soldiers from the San Francisco presidio.",
        pt: 4
      },
      {
        img: {
          size: "sm",
          desktopUrl: "../../../assets/stop3/8.png",
          mobileUrl: "../../../assets/stop3/8.png",
          footnote: "Portrait of General Mariano Vallejo",
          alt: "A painted portrait of General Mariano Vallejo"
        },
        pt: 3
      },
      {
        p: "Their orders were to <strong>close Mission Solano</strong> and distribute its assets to include the nearly <strong>900 Bay Area Indians</strong> who were essentially enslaved here. That’s not how things worked out, as you’ll hear about later.",
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop3/9.png",
          mobileUrl: "../../../assets/stop3/9.png",
          footnote: "Indians from the Bay area of San Francisco. By Louis Choris (1816)",
          alt: "A painting of Indians from the Bay area of San Francisco"
        },
        pt: 4
      },
      {
        title: "Honoring the Original Tribes",
        pt: 3
      },
      {
        p: "Before you leave Mission Solano — visit the granite memorial, the only one of its kind in California. It honors Coast Miwok, Pomo, Wappo and Wintun people who were baptized, given Christian names and buried here. Their descendants still live here.",
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop3/10.png",
          mobileUrl: "../../../assets/stop3/10.png",
          footnote: "Granite Memorial Honoring Coast Miwok, Pomo, Wappo and Wintun people.",
          alt: "A photo of the Granite Memorial outside of Mission San Francisco Solano"
        },
        pt: 2
      },
      {
        reflection: {
          title: "Visit the Granite Memorial",
          p: "Walk to the left side of the building to visit the granite memorial. This memorial represents the original tribes. Touch their names, read them aloud."
        },
        pt: 4
      }
    ],
    [
      {
        p: '<b>If these Walls Could Talk</b>'
      },
      {
        p: 'The Plaza didn’t just happen, California’s largest historic plaza has been the focus of deliberate planning.',
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop4/1.png",
          mobileUrl: "../../../assets/stop4/1.png",
          footnote: "Tertulia de Pulquería (1851) by Agustín Arrieta",
          alt: "Painted depiction of a gathering in a pulque bar"
        },
        pt: 4
      },
      {
        timebar: {
          date: "1830’s",
          title: "Started as a Home"
        },
        pt: 4
      },
      {
        p: "The building began in the 1830s. It was the home of an overseer at the mission.",
        pt: 2
      },
      {
        timebar: {
          date: "1837",
          title: "The First Saloon"
        },
        pt: 2
      },
      {
        p: "Antonio Ortega opened the pueblo’s first saloon, Pulqueria.",
        pt: 1
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop4/2.png",
          mobileUrl: "../../../assets/stop4/2.png",
          footnote: "7 Pulque drinks",
          alt: "Seven pulque drinks served on a tray"
        },
        pt: 2
      },
      {
        timebar: {
          date: "1849",
          title: "The Gold Rush"
        },
        pt: 3
      },
      {
        p: "Americans bought the saloon just before the Gold Rush and cashed in as the gold miner’s new watering hole.",
        pt: 2
      },
      {
        double_img: {
          desktopUrl_a: "../../../assets/stop4/3a.png",
          mobileUrl_a: "../../../assets/stop4/3a.png",
          footnote_a: "Gold Miners",
          alt_a: "Portrait of a gold miner with two pickaxes and a bag of gold",
          desktopUrl_b: "../../../assets/stop4/3b.png",
          mobileUrl_b: "../../../assets/stop4/3b.png",
          footnote_b: "",
          alt_b: "Portrait of a gold miner with a pickaxe"
        },
        pt: 3
      },
      {
        title: "These were legendary times.",
        pt: 1
      },
      {
        p: "The Blue Wing changed hands often over the years.",
        pt: 2
      },
      {
        zoom: {
          size: "lg",
          desktopUrl: "../../../assets/stop4/4.png",
          mobileUrl: "../../../assets/stop4/4.png",
          footnote: "Upstairs at the Blue Wing",
          alt: "Looking down the balcony of the Blue Wing Inn"
        },
        pt: 2
      },
      {
        timebar: {
          date: "1900's",
          title: "Augistino Pinelli"
        },
        pt: 4
      },
      {
        p: 'Augustino Pinelli made wine here in the early 1900’s.',
        pt: 2
      },
      {
        img: {
          size: "sm",
          desktopUrl: "../../../assets/stop4/6.png",
          mobileUrl: "../../../assets/stop4/6.png",
          footnote: "Press Democrat, Volume XXXVIII, Number 221, 20 September 1911",
          alt: "Press Democrat, Volume XXXVIII, Number 221, 20 September 1911"
        },
        pt: 4
      },
      {
        p: "He saved Sonoma from burning – putting out the fire with his wine.",
        pt: 1
      },
      {
        timebar: {
          date: "Forward",
          title: "Mr Sonoma"
        },
        pt: 4
      },
      {
        p: 'This family was so famous they named his son August Pinelli, Mr Sonoma.',
        pt: 2
      },
      {
        img: {
          size: "md",
          desktopUrl: "../../../assets/stop4/5.png",
          mobileUrl: "../../../assets/stop4/5.png",
          footnote: "August Pinelli",
          alt: "August Pinelli"
        },
        pt: 3
      },
      {
        h1: 'They called him <b>“Mr. Sonoma.”</b>',
        pt: 2
      },
      {
        p: "The Pinelli building, which survived the fire, is around the corner at <b>408 1st Street East.</b>",
      },
      {
        timebar: {
          date: "Current",
          title: "Closed"
        },
        pt: 4
      },
      {
        p: "The Blue Wing Adobe is part of Sonoma State Historic Park. It’s been closed for nearly 20 years. About the name — <strong>nobody knows why it’s called the Blue Wing Inn. I invite you to make up your own story.</strong>",
        pt: 3
      },
      {
        reflection: {
          title: "Can you find the adobe buildings?",
          p: "The Blue Wing Inn is built with adobe bricks. Look for other adobe buildings around the Plaza."
        },
        pt: 3
      },
      {
        test: {
          question: "What was used to save Sonoma and the Blue Wing Inn from a terrible fire?",
          answer: "August Pinelli's red wine"
        },
        pt: 4
      }
    ],
    [
      {
        location: "The Barracks",
        pt: 3
      },
      {
        title: "Schocken Hill",
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop5/1.png",
          mobileUrl: "../../../assets/stop5/1.png",
          footnote: "A photo of the “Old Barracks with a backdrop of Schocken Hill",
          alt: "A photo of the “Old Barracks with a backdrop of Schocken Hill"
        },
        pt: 2
      },
      {
        lgTxt: {
          p: "The mountain range was named after <b>Solomon Schocken.</b>",
          dark: false,
          py: 3
        },
        pt: 1
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop5/2.png",
          mobileUrl: "../../../assets/stop5/2.png",
          footnote: "A digitally remastered portrait of Solomon Schocken",
          alt: "A digitally remastered portrait of Solomon Schocken"
        },
        pt: 2
      },
      {
        timebar: {
          date: "1860",
          title: "Born in Poland"
        },
        pt: 3
      },
      {
        p: "Solomon Schocken, a Jewish man, became Sonoma’s first Jewish resident.",
        pt: 3
      },
      {
        timebar: {
          date: "1873",
          title: "Schocken’s Store"
        },
        pt: 3
      },
      {
        p: `He opened a store in the Toscano Hotel. His low prices made other Plaza
            merchants jealous so <b>they had him arrested for doing business on the sabbath.</b>`,
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop5/3.png",
          mobileUrl: "../../../assets/stop5/3.png",
          footnote: "A Sketch of Toscano Hotel",
          alt: "A Sketch of Toscano Hotel"
        },
        pt: 2
      },
      {
        p: `Schocken tried again to stay open on Sundays, <b>“Jewish Sabbath.”</b> But soon
            learned the law would not be swayed.`,
        pt: 3
      },
      {
        timebar: {
          date: "1878",
          title: "The Barracks"
        },
        pt: 4
      },
      {
        p: `Schocken struck a <b>deal</b> with <b>General Vallejo</b> and <b>purchased</b> the <b>Barracks</b> which
            became the <b>new location</b> of his <b>shop.</b>`,
        pt: 2
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop5/4.png",
          mobileUrl: "../../../assets/stop5/4.png",
          footnote: "A photograph of Schocken’s Shop",
          alt: "A photograph of Schocken’s Shop"
        },
        pt: 4
      },
      {
        lgTxt: {
          p: "Schocken was called <b>“the fairest merchant Sonoma ever had.”</b>",
          dark: true,
          py: 4
        },
        pt: 2
      },
      {
        p: `He opened <b>Sonoma’s first lumberyard</b> and eventually <b>supplied
            water and electricity to the town.</b>`,
        pt: 4
      },
      {
        timebar: {
          date: "1892",
          title: "The Quarry Business"
        },
        pt: 3
      },
      {
        p: `Schocken purchased what is now known as Schocken Hill and employed Italian
            immigrants to cut <b>cobblestones</b> for the <b>streets of San Francisco</b>.`,
        pt: 3
      },
      {
        p: `<b>Samuele Sebastiani</b> hauled cobblestones for Schocken until he saved
            enough to start his wine business.`,
        pt: 3
      },
      {
        img: {
          size: "lg",
          desktopUrl: "../../../assets/stop5/5.png",
          mobileUrl: "../../../assets/stop5/5.png",
          footnote: "A photo of Samuele Sebastiani founder and owner of Sebastiani Winery",
          alt: "A photo of Samuele Sebastiani founder and owner of Sebastiani Winery"
        },
        pt: 3
      },
      {
        p: `Schocken also helped the <b>Women's Club</b> beautify the Plaza and served on the
            <b>City Council</b>.<br><br>His generosity was fondly remembered. When kids entered his
            store, he would scoop out candy for them from a big jar.<br><br>He helped many people
            through hard times. It was said that <b>even Vallejo would have gone hungry without
            Schocken.”</b>`,
        pt: 3
      },
      {
        test: {
          question: "Where was Solomon Schocken’s first store?",
          answer: "The Toscano Hotel"
        },
        pt: 5
      }
    ],
    [{
      videoplay: {
        title: 'This stop includes video playback.',
        p: 'Please be aware of your suroundings while viewing.',
        videoTitle: 'Interview with Hank Marioni',
        videoContent:
            'Enjoy a recorded interview with Hank Marioni as he shares stories and photos from this classic Sonoma establishment. ',
        videoFooter: 'Video: Interview with Hank Marioni',
        videoImageLink: '../../../assets/stop6/1.png',
        videoLink: 'https://www.youtube.com/embed/w38fFtXP01Q'
      },
      pt: 3,
      },
      {
        quiz: {
          question: 'What country is Ticino in?',
          choices: [
            {
              choice: 'United States',
              answer: false,
            },
            {
              choice: 'China',
              answer: false,
            },
            {
              choice: 'Switzerland',
              answer: true,
            },
          ],
        },
      },
    ],
    [
      {
        location: 'Eldorado Hotel'
      },
      {
        title: 'Sonoma’s been a drinking town for nearly 200 years.',
        pt: 3,
      },
      {
        p: `Much like today, alcohol is one of the original attractions to Sonoma.`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop7/1.png',
          mobileUrl: '../../../assets/stop7/1.png',
          footnote: 'Aerial footage of Sonoma Plaza',
          alt: 'Aerial footage of Sonoma Plaza',
        },
        pt: 3,
      },
      {
        timebar: {
          date: '1851',
          title: 'The first Bar',
        },
        pt: 3,
      },
      {
        p: `Our pueblo’s first watering hole started as a home but soon became a pulqueria named the<b>Blue Wing Inn.</b>`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop7/2.png',
          mobileUrl: '../../../assets/stop7/2.png',
          footnote: 'Exterior facade of the Blue Wing Inn',
          alt: 'Exterior facade of the Blue Wing Inn',
        },
        p: `Next door, <b>Casa de Billiar</b>, a funky billiard hall, was our first gambling joint.`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop7/3.png',
          mobileUrl: '../../../assets/stop7/3.png',
          footnote: 'Painting “Tertulia de Pulquería” by Agustín Arrieta (1851)',
          alt: 'Painting “Tertulia de Pulquería” by Agustín Arrieta (1851)',
        },
        p: `Sonoma changed almost overnight with the start of the Gold Rush making alcohol and gambling a saught after past time. <b>Rich miners often paid with particles of gold.</b>`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop7/4.png',
          mobileUrl: '../../../assets/stop7/4.png',
          footnote:
            'Illustration: Conrad Reed finds gold…Harper’s New Monthly Magazine (1857)',
          alt: 'Illustration: Conrad Reed finds gold…Harper’s New Monthly Magazine (1857)',
        },
        p: `Kids, like the Cooper boys who lived at the Blue Wing Inn, would wash the floor to <b>see what the miners would leave behind.</b>`,
        pt: 3,
      },
      {
        title: 'Saloons sprang up and moved around the Plaza.',
        pt: 3,
      },
      {
        p: `The <b>Pioneer</b> started as a general store and was moved to Napa St. then back to Spain St., added a second story and today it’s a home.`,
        pt: 3
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop7/5.png',
          mobileUrl: '../../../assets/stop7/5.png',
          footnote:
            'Pioneer Saloon and Miller and Pauli store. Sonoma, CA, 1870s. Courtesy Sonoma County Library.',
          alt: 'Pioneer Saloon and Miller and Pauli store. Sonoma, CA, 1870s. Courtesy Sonoma County Library.',
        },
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop7/6.png',
          mobileUrl: '../../../assets/stop7/6.png',
          footnote: 'A woman enjoying wine at the El Dorado Kitchen and Hotel',
          alt: 'A woman enjoying wine at the El Dorado Kitchen and Hotel',
        },
      },
      {
        list: {
          title: 'You can still have a drink at these historic establisments today',
          values: [
            `The El Dorado Hotel`,
            `The Swiss Hotel`
          ]
        }
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop7/7.png',
          mobileUrl: '../../../assets/stop7/7.png',
          footnote:
            'Facade of the historic building where Taub Outpost is located',
          alt: 'Facade of the historic building where Taub Outpost is located',
        },
        p: `Look around. You’re probably just steps from an excellent cocktail or a lovely glass of wine.`,
        pt: 3,
      },
      {
        quiz: {
          question: 'What was the first bar in Sonoma?',
          choices: [
            {
              choice: 'Pioneer',
              answer: true,
            },
            {
              choice: 'Casa De Billars',
              answer: false,
            },
            {
              choice: 'Blue Wing Inn',
              answer: false,
            },
          ],
        },
      },
    ],
    [
      {
        location: 'Sign of the Bear Shop',
        pt: 3,
      },
      {
        title: 'Gone but not forgotten',
        pt: 3,
      },
      {
        p: `During the <b>Gold Rush</b>, over 300,000 people flooded into California from around the world – Europe, Central and South America, Australia and China. `,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          lottieImg: true,
        },
        pt: 3,
      },
      {
        timebar: {
          date: "1850's",
          title: 'Seeking Fortune',
        },
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop8/2.png',
          mobileUrl: '../../../assets/stop8/2.png',
          footnote: 'William Shew. Jumped Ship in San Francisco. Ca. 1852.',
          alt: 'William Shew. Jumped Ship in San Francisco. Ca. 1852.',
        },
        pt: 3,
      },
      {
        p: `Young Chinese men sailed across the Pacific to seek their fortune on <b>Gam Saan, or "Gold Mountain.”</b>`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop8/3.png',
          mobileUrl: '../../../assets/stop8/3.png',
          footnote: 'Chinese  miners use rockers (also called cradles) to sift through material in search of gold during the California Gold Rush.',
          alt: 'Chinese  miners use rockers (also called cradles) to sift through material in search of gold during the California Gold Rush.',
        },
        pt: 3,
      },
      {
        p: `Only a few struck it rich but found labor in <b>agriculture and building the railroad.</b>`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop8/4.png',
          mobileUrl: '../../../assets/stop8/4.png',
          footnote: 'Chinese Man (c. 1853. Courtesy: Oakland Museum of California',
          alt: 'Chinese Man (c. 1853. Courtesy: Oakland Museum of California',
        },
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop8/5.png',
          mobileUrl: '../../../assets/stop8/5.png',
          footnote: "Chinese railroad workers",
          alt: 'Chinese railroad workers',
        },
        pt: 3,
      },
      {
        timebar: {
          date: '1860-1870',
          title: 'Population skyrockets',
        },
        pt: 3,
      },
      {
        p: `By the 1860s <b>hundreds worked on ranches</b> around Sonoma. Others found labor in overseeing <b>winemaking.</b>`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop8/6.png',
          mobileUrl: '../../../assets/stop8/6.png',
          footnote: 'Ho Po: Courtesy the Sonoma Index Tribune',
          alt: 'Ho Po: Courtesy the Sonoma Index Tribune',
        },
        pt: 3,
      },
      {
        p: `By 1870, nearly <b>25% of the people</b> in Sonoma were <b>Chinese.</b>`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop8/8.png',
          mobileUrl: '../../../assets/stop8/8.png',
          footnote: ' Hi-Lo House. Courtesy: Sonoma Valley Sun',
          alt: ' Hi-Lo House. Courtesy: Sonoma Valley Sun',
        },
        pt: 3,
      },
      {
        p: `Hop Wo ran the “Hi-Lo House,” on the Plaza, a combination laundry, store and employment office. It was near today’s Sign of the Bear. `,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop8/9.png',
          mobileUrl: '../../../assets/stop8/9.png',
          footnote: 'Sign of the Bear',
          alt: 'Sign of the Bear',
        },
        pt: 3,
      },
      {
        p: `Other Chinese businesses and homes were clustered near the Sonoma Hotel.`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop8/10.png',
          mobileUrl: '../../../assets/stop8/10.png',
          footnote: 'Sanborn Fire Insurance Map (1888)',
          alt: 'Sanborn Fire Insurance Map (1888)',
        },
        pt: 3,
      },
      {
        p: `Nineteenth century neighbors recalled how <b>“you could hear the picking of Chinese banjos and musical kites strung with rubber bands buzzing in the wind”</b> over the wide-open Plaza, which was not yet planted with trees.`,
        pt: 3,
      },
      {
        timebar: {
          date: "Late 1870's",
          title: 'Anti-Chinese Racism',
        },
        pt: 3,
      },
      {
        p: `By the late 1870s, anti-Chinese racism led to discrimination and violence.`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop8/11.png',
          mobileUrl: '../../../assets/stop8/11.png',
          footnote: '1882. Courtesy: Library of Congress [New York] : [Frank Leslie], 1882. Courtesy: Library of Congress.jpg]',
          alt: '1882. Courtesy: Library of Congress [New York] : [Frank Leslie], 1882. Courtesy: Library of Congress.jpg] ',
        },
        pt: 3,
      },
      {
        p: `State laws made it <b>illegal for them to own property</b>, bring over their wives and families, or even have their last remains returned to China. In the face of such prejudice, Sonoma’s <b>Chinese community disappeared</b>. What once was a vibrant thread in our local culture has been nearly erased, leaving an almost invisible wound.`,
        pt: 3,
      },
      {
        p: '<b>They are not forgotten.</b>'
      },
      {
        quiz: {
          question: 'When did discrimination hit?',
          choices: [
            {
              choice: 'Early 1870’s',
              answer: false,
            },
            {
              choice: 'Early 1870’s',
              answer: false,
            },
            {
              choice: 'Late 1870’s',
              answer: true,
            },
          ],
        },
      },
    ],
    [
      {
        videoplay: {
          title: 'This stop includes video playback.',
          p: 'Please be aware of your suroundings while viewing.',
          videoTitle: 'The Duck Pond',
          videoContent: 'This video is an introduction to Sonoma’s beloved Duck pond and it’s signficance. The duck pond, a ‘man-made’ feature, echoes Sonoma’s landscape. ',
          videoFooter: 'Video: The Duck Pond',
          videoImageLink: '../../../assets/stop9/1.png',
          videoLink: "https://www.youtube.com/embed/4cyyJH2_Ehs"
        },
        pt: 3,
      },
      {
        quiz: {
          question: 'Who called Sonoma a Fountain of Fountains?',
          choices: [
            {
              choice: 'General Mariano Vallejo',
              answer: false,
            },
            {
              choice: 'Unknown',
              answer: false,
            },
            {
              choice: 'Father Altimira',
              answer: true,
            },
          ],
        },
      },
    ],
    [
      {
        location: "Picnic Area",
        pt: 3
      },
      {
        audioPlay: {
          title: 'This stop includes audio playback.',
          p: 'Please be aware of your suroundings while listening.',
        },
        pt: 3,
      },
      {
        p: '<b>Billy Lynch</b>',
        pt: 3
      },
      {
        p: `Bill Lynch remembers the Plaza when he was a boy in the 1950s.`,
        pt: 3,
      },
      {
        img: {
          size: 'lg',
          desktopUrl: '../../../assets/stop10/1.png',
          mobileUrl: '../../../assets/stop10/1.png',
          footnote: 'Photo of Bill Lynch telling his story',
          alt: 'Photo of Bill Lynch telling his story',
        },
        pt: 3,
      },
    ],
];

export const LOTTIEANIMATION = {
  'title': 'Detecting your location...',
  'content': 'Sonoma Plaza History uses GPS to help you navigate'
}

export const TRACKLOCATION = {
  'title': 'We couldn’t locate your GPS location.',
  'content': 'You can still enjoy the tour without GPS enabled.',
  'btnContent': 'Continue without GPS enabled',
  'linkContent': 'Learn how to enable GPS-Location Services for your device '
}

export const WELCOMEMAP = {
  'title': 'Welcome to the Map!',
  'content': 'Walk to the destination marked on the map, and choose “I’ve arrived” when near.',
  'btnContent': 'I understand',
}

export const WELCOMETOURSTOP = {
  "title":"Welcome to the first tour stop. ",
  "content1":"Many of the tour stops have content such as audio playback, video, text and images.",
  "content2":"Press play (when applicable) and scroll or swipe to view additional content.",
  'btnContent': 'I understand',
}